import { defineStore } from 'pinia'
import { getCartList } from '~/api/mall'
import config from '~/config/index'

export const useCartStore = defineStore('cartStore', {
  state: () => ({
    cartNum: 0,
    cartList: [],
    cartTotalQuantity: 0,
  }),
  actions: {
    getCartInfo() {
      return {
        cartList: this.cartList,
        cartNum: this.cartNum,
        cartTotalQuantity: this.cartTotalQuantity,
      }
    },
    async getCartData() {
      const appToken = window.localStorage.getItem(config.appTokenKey)

      let cartList = []
      if (appToken) {
        const responseCartList = await getCartList()
        cartList = responseCartList.data.dataList
      }
      else {
        const localCartData = window.localStorage.getItem('local_cart_items')
        if (localCartData) {
          cartList = JSON.parse(localCartData)
        }
      }
      this.cartList = cartList
      this.cartNum = cartList.length
      this.cartTotalQuantity = cartList.reduce((acc, item) => acc + item.buyAmount, 0)
    },
    async addToCart() {

    },
    async removeFromCart() {

    },
  },
})
